// Откуда пришёл пользователь: UTM-метки, реферальный код (?ref=) и промокод (?promo=) из ссылки.
// Первое касание храним в localStorage до регистрации и один раз отправляем на сервер после входа.
// Промокод из ссылки запоминаем отдельно — его подставит форма оплаты.

const FIRST_TOUCH_KEY = 'svod_first_touch';
const SENT_KEY = 'svod_first_touch_sent';
const PROMO_KEY = 'svod_promo';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const storage = {
    get(key) {
        try { return window.localStorage.getItem(key); } catch { return null; }
    },
    set(key, value) {
        try { window.localStorage.setItem(key, value); } catch { /* приватный режим — без атрибуции */ }
    },
    remove(key) {
        try { window.localStorage.removeItem(key); } catch { /* ignore */ }
    },
};

export function captureAttribution(location = window.location, referrer = document.referrer) {
    const params = new URLSearchParams(location.search);
    const promo = (params.get('promo') || '').trim();
    if (promo) storage.set(PROMO_KEY, promo.toUpperCase());

    const touch = {};
    UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) touch[key] = value.slice(0, 200);
    });
    const ref = (params.get('ref') || '').trim();
    if (ref) touch.ref_code = ref.toUpperCase().slice(0, 64);
    if (promo) touch.promo_code = promo.toUpperCase().slice(0, 64);
    let externalReferrer = null;
    try {
        if (referrer && new URL(referrer).host !== location.host) externalReferrer = referrer.slice(0, 200);
    } catch { /* некорректный referrer */ }
    if (externalReferrer) touch.referrer = externalReferrer;

    // Первое касание не перезаписываем; заход без меток и внешнего источника не сохраняем
    if (!Object.keys(touch).length || storage.get(FIRST_TOUCH_KEY)) return;
    touch.landing_path = location.pathname.slice(0, 200);
    touch.first_seen_at = new Date().toISOString();
    storage.set(FIRST_TOUCH_KEY, JSON.stringify(touch));
}

export async function sendAttributionOnce(api) {
    if (storage.get(SENT_KEY)) return;
    const raw = storage.get(FIRST_TOUCH_KEY);
    if (!raw) return;
    let touch;
    try { touch = JSON.parse(raw); } catch { storage.remove(FIRST_TOUCH_KEY); return; }
    try {
        await api.post('/users/me/attribution', touch);
        storage.set(SENT_KEY, '1');
    } catch {
        // Попробуем при следующем открытии кабинета
    }
}

export function getStoredPromo() {
    return storage.get(PROMO_KEY) || '';
}

export function clearStoredPromo() {
    storage.remove(PROMO_KEY);
}
